import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Heart, LineChart, Sparkles } from "lucide-react";

const FEATURES = [
  {
    icon: Heart,
    title: "Log how you feel",
    body: "A quick, judgment-free check-in — pick an emotion, an intensity, and a note if you want one.",
  },
  {
    icon: LineChart,
    title: "See your Moodscape",
    body: "Your emotions plotted over time, so patterns you'd otherwise miss become visible.",
  },
  {
    icon: Sparkles,
    title: "Get gentle feedback",
    body: "Reflections on your recent patterns — streaks, trends, and what's been showing up most.",
  },
];

export default function Home() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const startNow = () => navigate(user ? "/moodscape" : "/auth?mode=register");

  return (
    <main>
      <section className="max-w-5xl mx-auto px-6 sm:px-12 pt-20 sm:pt-28 pb-16 sm:pb-20 text-center">
        <h1 className="font-serif-display text-5xl sm:text-6xl text-[var(--primary)] leading-tight fade-up">
          Understand how you feel,
          <br />
          one day at a time.
        </h1>
        <p className="mt-6 max-w-xl mx-auto text-base sm:text-lg text-[var(--text-muted)] fade-up delay-1">
          Feelique is a simple mood tracker. Log your emotions, watch your Moodscape take shape,
          and get quiet feedback on the patterns underneath.
        </p>
        <div className="mt-10 fade-up delay-2">
          <Button
            onClick={startNow}
            className="rounded-full bg-[var(--primary)] hover:bg-[var(--primary-hover)] text-white px-10 py-6 text-lg"
          >
            Start Now
          </Button>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 sm:px-12 pb-24 sm:pb-32">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {FEATURES.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              className="bg-white rounded-[1.5rem] p-8 border border-[var(--border)] shadow-[0_8px_30px_-12px_rgba(0,0,0,0.08)]"
            >
              <div className="w-11 h-11 rounded-full bg-[var(--surface)] flex items-center justify-center mb-5">
                <Icon size={20} className="text-[var(--primary)]" />
              </div>
              <h3 className="text-xl font-medium mb-2">{title}</h3>
              <p className="text-sm leading-relaxed text-[var(--text-muted)]">{body}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
